export enum LoginFormFields {
    Username = 'username',
    Password = 'password',
    RememberMe = 'remember_me'
}